const Fonts = {
    MassiliaRegular: "MassiliaRegular",
    MassiliaBold: "MassiliaBold",
    MassiliaBoldOblique: "MassiliaBoldOblique",
    MassiliaOblique: "MassiliaOblique",
    MassiliaMedium: "MassiliaMedium",
    MassiliaMediumOblique: "MassiliaMediumOblique",
    MassiliaLight: "MassiliaLight",
    MassiliaLightOblique: "MassiliaLightOblique",
    MassiliaExtraLight: "MassiliaExtraLight",
    MassiliaExtraLightOblique: "MassiliaExtraLightOblique",
    MassiliaExtraBold: "MassiliaExtraBold",
}

const FontsWeight = {
    Light: 300,
    Regular: 500,
    Medium: 600,
    Bold: 700,
    ExtraBold: 800,
}

export {
    Fonts,
    FontsWeight
}